import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Real Estate Agent Assist social accounts (@reassistapp).
const reassistSocialLinks = [
  {
    name: "Instagram",
    icon: "fa-brands fa-instagram",
    url: "https://www.instagram.com/reassistapp",
  },
  {
    name: "Facebook",
    icon: "fa-brands fa-facebook",
    url: "https://www.facebook.com/reassistapp",
  },
  {
    name: "TikTok",
    icon: "fa-brands fa-tiktok",
    url: "https://www.tiktok.com/@reassistapp",
  },
  {
    name: "YouTube",
    icon: "fa-brands fa-youtube",
    url: "https://www.youtube.com/@reassistapp",
  },
];

const AppSocialLinks = ({ label, align = "center", tone = "light", className }) => {
  return (
    <div style={{ textAlign: align }} className={className ? "text-center text-lg-start" : undefined}>
      {label && (
        <p style={{ ...styles.label, color: tone === "dark" ? "#6B5C4F" : "#ACACAC" }}>
          {label}
        </p>
      )}
      <div
        className={className}
        style={{
          ...styles.row,
          justifyContent: align === "center" ? "center" : "flex-start",
        }}
      >
        {reassistSocialLinks.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={tone === "dark" ? "social-link social-link-dark" : "social-link"}
            aria-label={`Real Estate Agent Assist on ${link.name}`}
            title={link.name}
          >
            <FontAwesomeIcon icon={link.icon} size="xl" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default AppSocialLinks;

const styles = {
  label: {
    fontSize: 14,
    marginBottom: 8,
  },
  row: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap",
  },
};
